"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var localstorage_1 = require("./localstorage");

var ENV = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : undefined;
var localstorage = new localstorage_1.LocalStorage(ENV);

if (process.env.NODE_ENV !== 'production') {
  if (!localstorage.supported) {
    console.warn("You environment doesn't support localStorage");
  }
}

exports.default = localstorage;